
export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return 'Phone number is required';
  }
  if (phoneNumber.length < 13) {
    return 'Phone number must be at least 13 characters long';
  }
  if (phoneNumber.substring(0, 3) !== '+25') {
    return 'Phone number must start with +25';
  }
  return null;
}; 